module.exports = __webpack_public_path__ + "static/media/acc.94d562c1.png";